import './scss/botao-comprar-timer.scss'

import { Device } from "@/components/vitrine/data/device"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { isDev } from "@/utils/enviroment-detector"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import { useCountdown } from "@/utils/useCountdown"
import { zordDbDatetimeToStr } from "@/utils/zordDbDatetimeToStr"

interface BotaoComprarTimerProps {
    produto: Produto
    validaTempoVitrine: boolean
    device: number
    zordHintLoading: string
    vitrineButtonAddToCart: string
}

export function BotaoComprarTimer({
    produto,
    validaTempoVitrine,
    vitrineButtonAddToCart,
    device,
    zordHintLoading
}: Readonly<BotaoComprarTimerProps>) {
    const dataFimItem = produto.data_fim ? zordDbDatetimeToStr(produto.data_fim) : null
    const { dias, horas, minutos, segundos } = useCountdown(produto.data_fim)

    return (
        <>
            {((produto.data_fim && new Date(produto.data_fim).getTime() > 0) && validaTempoVitrine && (produto.qtde_estoque > 0)) && (
                <div className="timer-vitrine tipo flex center" data-fim={dataFimItem} data-diff-days="true">
                    <div className="chronometer-icon flex center justify-center">
                        <img
                            className="lazyload lazyload-svg"
                            src={isDev() ? getResourceFromS3('assets/global/vitrines-landing-page', 'icon-timer.svg') : zordHintLoading}
                            data-src={getResourceFromS3('assets/global/vitrines-landing-page', 'icon-timer.svg')}
                            alt="Tempo restante"
                            title="Tempo restante"
                            width="24"
                            height="24"
                        />
                    </div>
                    <div className="chronometer-timer flex column center justify-center">
                        TERMINA EM:
                        <div className="alinha-contador countdown-timer flex center justify-center">
                            <div className="ctn dia flex">
                                <span className="count">{dias}</span>
                                <span className="text-countdown">D</span>
                            </div>
                            <div className="ctn hora flex">
                                <span className="count">{horas}</span>
                                <span className="text-countdown">:</span>
                            </div>
                            <div className="ctn min flex">
                                <span className="count">{minutos}</span>
                                <span className="text-countdown">:</span>
                            </div>
                            <div className="ctn seg flex">
                                <span className="count">{segundos}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        className="buy-button-timer flex center justify-center"
                        style={[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? { display: "none" } : {}}
                    >
                        <span className="buy-button-text buy-button-text-timer">
                            {vitrineButtonAddToCart}
                        </span>
                    </div>
                </div>
            )}

            {(!validaTempoVitrine || ([Device.MOBILE, Device.APP, Device.TABLET].includes(device)) || (produto.data_fim == null || Number(produto.data_fim) <= 0) || produto.qtde_estoque <= 0) && (
                <div className={`buy-button flex center justify-center${produto.qtde_estoque <= 0 ? ' sem-estoque' : ''}`}>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M8.25 9.75V6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75V9.75"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <span className="buy-button-text">{produto.qtde_estoque > 0 ? vitrineButtonAddToCart : 'Sem estoque'}</span>
                </div>
            )}
        </>
    )
}
